import { Icon } from "@iconify/react"
import { MantineColor, Paper, Stack, Text } from "@mantine/core"
import { Link } from "react-router-dom"

type LinkCardProps = {
    label: string
    icon: string
    to: string
    color: MantineColor
}

export function LinkCard({
    label,
    icon,
    to,
    color
}: LinkCardProps) {

    return (
        <Paper
            component={Link}
            to={to}
            shadow="sm"
            bg={color}
            h={{base:150,sm:200}}
            p={20}
        >
            <Stack
                justify="space-between"
                h="100%"
            >
                <Text
                    fw={900}
                    c="black"
                    size="2rem"
                >{label}</Text>
                <Icon icon={icon} color="black" width={60} style={{alignSelf:'flex-end'}}/>
            </Stack>
        </Paper>
    )
}